import React from 'react'
import { format } from 'date-fns'
import { enUS } from 'date-fns/locale'
import WorkCover, { getWorkCoverUrl } from './WorkCover'

const COVER_SIZE = 240

// Top of the Work Details pages: a large cover over a blurred, faded copy of itself.
// `children` renders under the facts (e.g. the Edit Work link).
const WorkHeader = ({ work, children }) => {
  const coverUrl = getWorkCoverUrl(work.cover)

  return (
    <section className='relative overflow-hidden'>
      {coverUrl && (
        <div
          aria-hidden='true'
          className='absolute inset-0 pointer-events-none'
        >
          <img
            src={coverUrl}
            alt=''
            className='w-full h-full object-cover scale-125 blur-3xl opacity-40'
          />
          <div className='absolute inset-0 bg-gradient-to-r from-white/40 via-white/80 to-white' />
        </div>
      )}
      <div className='relative py-4 flex flex-col md:flex-row items-center gap-8 md:gap-10'>
        <WorkCover
          title={work.title}
          cover={work.cover}
          size={COVER_SIZE}
          className='rounded-xl shadow-2xl ring-1 ring-black/10'
        />
        <div className='flex-1 min-w-0 text-center md:text-left'>
          <div className='flex flex-wrap justify-center md:justify-start gap-2 mb-4'>
            <div className='font-normal tracking-wider text-white py-1.5 px-4 rounded-full bg-main'>{work.compname}</div>
            <div className='tracking-wide py-1.5 px-4 rounded-full bg-white border text-main-alt border-main-alt'>{work.status}</div>
            {work.matchday && (
              <div className='tracking-wide py-1.5 px-4 rounded-full bg-white/70 border border-neutral-200 text-neutral-700'>
                {work.matchday}
              </div>
            )}
          </div>
          <h1 className='text-3xl lg:text-4xl font-bold text-main mb-1'>{work.title}</h1>
          {work.author && <div className='text-lg text-neutral-500 mb-5'>by {work.author}</div>}
          <div className='flex flex-wrap justify-center md:justify-start gap-x-10 gap-y-2 text-neutral-700'>
            {work.language && (
              <div>
                <span className='text-neutral-400 text-sm'>Language</span>
                <div className='font-semibold'>{work.language}</div>
              </div>
            )}
            {work.episodes != null && (
              <div>
                <span className='text-neutral-400 text-sm'>Episodes</span>
                <div className='font-semibold'>{Number(work.episodes).toLocaleString()}</div>
              </div>
            )}
            <div>
              <span className='text-neutral-400 text-sm'>Monitoring since</span>
              <div className='font-semibold'>{format(new Date(work.date), 'EEE, do MMM yyyy', { locale: enUS })}</div>
            </div>
          </div>
          {children && <div className='mt-6'>{children}</div>}
        </div>
      </div>
    </section>
  )
}

export default WorkHeader
